import Blue from "~/core";

new Blue({
	name: 'Header Nav',
	selector: 'header.header',
	setup(header) {
    const toggle = [...header.querySelectorAll('.nav-toggle')];
    const main = header.querySelector('.nav-main')

		this.$addEvents(toggle, 'click', () => {
      header.classList.toggle('nav-active');

      if (header.classList.contains('nav-active')) {
        this.$scrollLock.lock(main)
      }
      else {
        this.$scrollLock.unlock(main)
      }
    });
	},
});

new Blue({
	name: 'Header Accordion',
	selector: '.nav-subList',
	setup(content) {
    if (!this.$screen.lg.matches) {
      const trigger = content.closest('.nav-item').querySelector('.nav-label');
      trigger.classList.add('has-children');
      const eventString = 'click enter';
      const conditionFunc = (e) => { return trigger.tagName !== 'A' || e.target.tagName !== 'SPAN' };
			let mobileToggleConfig = {
				trigger,
				content,
        eventString,
        conditionFunc
			};
			new this.$toggle(mobileToggleConfig);
		}
	},
});

new Blue({
	name: 'Header Body Adjust',
	selector: 'header.header',
	setup(header) {
		const body = document.body;
		const rail = header.querySelector('.header-rail');
		const alert = header.querySelector('.header-alert');
    const newspaper = document.querySelector('.newspaper');
    let hero;
    if (newspaper) {
      hero = newspaper.querySelector('.newspaper-hero');
    }
    const page = document.querySelector('.page');
		const adjust = () => {
			if (this.$screen.xl.matches) {
				body.style.paddingLeft = `${rail.offsetWidth}px`;
				if (alert) {
					body.style.paddingTop = `${alert.offsetHeight}px`;
					rail.style.top = `${alert.offsetHeight}px`;
          page.style.height = `calc(100vh - ${alert.offsetHeight}px)`;
				}
				if (newspaper) {
					newspaper.style.marginLeft = `-${rail.offsetWidth}px`;
          newspaper.style.marginTop = '';

          hero.style.paddingLeft = `${rail.offsetWidth}px`;
          hero.style.paddingRight = `${rail.offsetWidth}px`;

					if (alert) {
            newspaper.style.paddingTop = `${alert.offsetHeight}px`;
						newspaper.style.marginTop = `-${alert.offsetHeight}px`;
					}
				}
			} else {
				body.style.paddingLeft = '';
				body.style.paddingTop = '';
				body.style.marginLeft = '';
        body.style.marginTop = '';
        page.style.height = '';
				if (newspaper) {
          newspaper.style.paddingLeft = '';
					newspaper.style.marginLeft = '';
					newspaper.style.paddingTop = '';
          newspaper.style.marginTop = `-${rail.offsetHeight}px`;
          hero.style.paddingLeft = '';
          hero.style.paddingRight = '';
				}
			}
		};

		this.$addEvents(window, 'resize orentationchange', adjust);
		adjust();
	},
});

